import React from "react";
import Slider from "./Slider";
import styles from "./Testimonials.module.css";

export default function Testimonials() {
  return (
    <section className={styles.testimonials}>
      <div className={styles.container}>
        <h3>Testimonials & Impact</h3>
        <Slider />
      </div>
    </section>
  );
}
